import { Observable } from 'rxjs/Observable';
import { HttpOptions } from './interfaces';

// Class-interface for angular
// provide: HttpClientAdapter, use: AngularHttpClient
export abstract class HttpClientAdapter {

  get(url: string, params: { [name: string]: string }, options: HttpOptions = {}): Observable<any> {
    return;
  }

  post(url: string, params: { [name: string]: string }, body: any, options: HttpOptions = {}): Observable<any> {
    return ;
  }

  put(url: string, params: { [name: string]: string }, body: any | null, options: HttpOptions = {}): Observable<any> {
    return ;
  }

  patch(url: string, params: { [name: string]: string }, body: any | null, options: HttpOptions = {}): Observable<any> {
    return ;
  }

  delete(url: string, params: { [name: string]: string }, options: HttpOptions = {}): Observable<any> {
    return ;
  }
}
